<script lang="ts">
    import Searchbar from "./Searchbar.svelte"
    let {
        color,
    }: {
        color: "bright" | "dark"
    } = $props()
</script>

<Searchbar {color} icon="search" openSearch={true} value="de" placeholder="Suche" />
